import * as React from "react";

import { DropdownSelect } from "../../../ui/dropdown-select";
import { Switch } from "../../../ui/switch";
import { Period } from "../../periods";
import { SectionLegend } from "./SectionLegend";
import { getComparisonChoices, toDropdownOption } from "./periodChoices";

interface ComparisonSectionProps {
  focusPeriod: Period;
  comparisonPeriod: Period;
  autoMatchComparison: boolean;
  reportingYears: Period[];
  timeZone: string;
  onSelectComparison: (period: Period) => void;
  onChangeAutoMatch: (checked: boolean) => void;
}

// What the focus is compared with: the one it is matched to automatically, or one picked from what
// fits the focus
export function ComparisonSection({
  focusPeriod,
  comparisonPeriod,
  autoMatchComparison,
  reportingYears,
  timeZone,
  onSelectComparison,
  onChangeAutoMatch,
}: ComparisonSectionProps) {
  const choices = getComparisonChoices(focusPeriod, reportingYears, timeZone);
  const group = focusPeriod.sameDatesLastYear ? "Earlier years" : "Reporting year";

  return (
    <fieldset className="tw:m-0 tw:grid tw:min-w-0 tw:gap-2 tw:border-0 tw:p-0">
      <SectionLegend swatchClass="tw:bg-(--chart-2)" title="Comparison" />
      <label className="tw:mb-0 tw:flex tw:cursor-pointer tw:items-center tw:justify-between tw:gap-2 tw:text-sm tw:font-normal tw:text-neutral-500">
        Auto-match prior period
        <Switch checked={autoMatchComparison} onCheckedChange={onChangeAutoMatch} />
      </label>
      <DropdownSelect
        value={comparisonPeriod.key}
        onValueChange={(key) =>
          onSelectComparison(choices.find((choice) => choice.key === key) ?? comparisonPeriod)
        }
        options={choices.map((period) => toDropdownOption(period, group))}
        triggerClassName="tw:w-full"
      />
      <p className="tw:m-0 tw:text-xs tw:text-neutral-500 tw:italic">
        {autoMatchComparison
          ? "Suggested automatically from Focus. Picking another period turns this off."
          : "Pick another period to compare with Focus."}
      </p>
    </fieldset>
  );
}
